import React from "react";
import { FC } from "react";
import { ISchool } from "../../../types";
import { makeStyles, Theme } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import FavoriteIcon from "./FavoriteIcon";
import SchoolIcon from "../../../../../assets/svg/school.svg";
import CardActions from "@material-ui/core/CardActions";

interface SchoolCardProps {
  school: ISchool;
  title: any;
  image?: string;
  divider?: boolean;
  subTitle?: string;
  showFavorite?: boolean;
  disableGutters?: boolean;
  action?: React.ReactNode;
  footer?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  header: {
    "& .MuiCardHeader-action": {
      alignSelf: "center",
    },
  },
  avatar: {
    height: 50,
    width: 50,
    backgroundColor: "transparent",
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  cardContent: {
    paddingBottom: "0!important",
  },
  actions: {
    padding: "0!important",
    marginTop: theme.spacing(2),
  },
}));

const SchoolCard: FC<SchoolCardProps> = React.memo(
  ({
    school,
    title,
    image,
    divider = true,
    subTitle,
    showFavorite = true,
    disableGutters,
    children,
    action,
    footer,
    ...props
  }) => {
    const classes = useStyles();

    return (
      <Card className={classes.root}>
        <CardHeader
          title={title}
          titleTypographyProps={{ className: classes.title }}
          className={classes.header}
          subheader={subTitle}
          avatar={
            <Avatar
              className={classes.avatar}
              src={school.image || SchoolIcon}
            />
          }
          action={action || (showFavorite && <FavoriteIcon school={school} />)}
        />
        {divider && <Divider className={classes.divider} />}
        <CardContent className={classes.cardContent}>{children}</CardContent>
        {footer && (
          <CardActions className={classes.actions}>{footer}</CardActions>
        )}
      </Card>
    );
  },
);

export default SchoolCard;
